import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CommentsState } from '@app/core/store/reducers/comments';

const getCommentsFeatureState = createFeatureSelector<CommentsState>('comments');

export const getMIPSComments = createSelector(getCommentsFeatureState, (state: CommentsState) => state.mipsComments);

export const getCommentCount = createSelector(getCommentsFeatureState, (state) => state.commentCount);

export const getMaterialCommentCount = createSelector(getCommentsFeatureState, (state) => state.materialCommentCount);

export const getWorkLineCommentCount = createSelector(getCommentsFeatureState, (state) => state.workLineCommentCount);
